<template>
	<div class="auction">
		<div class="category">
			<div :class="'item ' + (categoryIndex == index ? 'item-select' : '')" @click="changeCategory(index)"
				v-for="(item,index) in category" :key="index">
				{{item}}
			</div>
		</div>
		<div class="table">
			<div class="table-item" v-show="categoryIndex == 0">
				<div class="table-title">
					全部数据（{{pageConfig.total}}）
				</div>
				<div class="table-box">
					<el-table ref="filterTable" :data="tableData" style="width: 100%" :border="true"
						:header-cell-style="{background:'#eaf0fa'}">
						<el-table-column label="数字藏品" width="400" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-commodity">
									<div class="space-commodity-image">
										<img :src="$pub.imageUrl+scope.row.lotPictrueUrl" alt="">
									</div>
									<div class="space-commodity-info">
										<div class="space-commodity-name">
											{{scope.row.lotName}}
										</div>
										<div class="space-commodity-author">
											{{scope.row.lotAuthor}}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="价格(元)" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								起拍价：<br>¥{{scope.row.startPrice}}
							</template>
						</el-table-column>
						<el-table-column label="状态" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<span v-if="scope.row.auctionStatus==1">即将开始</span>
								<span v-if="scope.row.auctionStatus==2">正在进行</span>
								<span v-if="scope.row.auctionStatus==3">已结束</span>
								<span v-if="scope.row.auctionStatus==4">流拍</span>
							</template>
						</el-table-column>
						<el-table-column label="时间" width="180" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								开拍时间：<br>{{scope.row.startTime}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-button">
									<div class="space-button-item space-button-red"
										@click="scopeButtonClick(scope.row, 'delete')">
										<i class="el-icon-delete"></i>
										取消收藏
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="table-item" v-show="categoryIndex == 1">
				<div class="table-title">
					全部数据（{{pageConfig.total}}）
				</div>
				<div class="table-box">
					<el-table ref="filterTable" :data="tableData" style="width: 100%" :border="true"
						:header-cell-style="{background:'#eaf0fa'}">
						<el-table-column label="数字藏品" width="400" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-commodity">
									<div class="space-commodity-image">
										<img :src="$pub.imageUrl+scope.row.lotPictrueUrl" alt="">
									</div>
									<div class="space-commodity-info">
										<div class="space-commodity-name">
											{{scope.row.lotName}}
										</div>
										<div class="space-commodity-author">
											{{scope.row.lotAuthor}}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="价格(元)" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								当前价：<br>¥{{scope.row.currentPrice}}
							</template>
						</el-table-column>
						<el-table-column label="状态" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<span v-if="scope.row.auctionStatus==1">即将开始</span>
								<span v-if="scope.row.auctionStatus==2">正在进行</span>
								<span v-if="scope.row.auctionStatus==3">已结束</span>
								<span v-if="scope.row.auctionStatus==4">流拍</span>
							</template>
						</el-table-column>
						<el-table-column label="时间" width="180" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								截止时间：<br>{{scope.row.endTime}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-button">
									<div class="space-button-item space-button-blue" v-if="scope.row.auctionStatus == 2"
										@click="scopeButtonClick(scope.row,'plus')">
										<i class="el-icon-money"></i>
										去出价
									</div>
									<div class="space-button-item space-button-blue"
										v-if="scope.row.auctionStatus == 3 && scope.row.lotOrderId && scope.row.payStatus == 0"
										@click="scopeButtonClick(scope.row, 'order')">
										<i class="el-icon-money"></i>
										去支付
									</div>
									<div class="space-button-item space-button-blue"
										@click="scopeButtonClick(scope.row, 'check')">
										<i class="el-icon-wallet"></i>
										查看保证金
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="table-item" v-show="categoryIndex == 2">
				<div class="table-title">
					全部数据（{{pageConfig.total}}）
				</div>
				<div class="table-box">
					<el-table ref="filterTable" :data="tableData" style="width: 100%" :border="true"
						:header-cell-style="{background:'#eaf0fa'}">
						<el-table-column label="数字藏品" width="400" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-commodity">
									<div class="space-commodity-image">
										<img :src="$pub.imageUrl+scope.row.lotPictrueUrl" alt="">
									</div>
									<div class="space-commodity-info">
										<div class="space-commodity-name">
											{{scope.row.lotName}}
										</div>
										<div class="space-commodity-author">
											{{scope.row.lotAuthor}}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="价格(元)" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								成交价：<br>¥{{scope.row.payPrice}}
							</template>
						</el-table-column>
						<el-table-column label="状态" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								{{scope.row.auctionStatus == 3 ? (scope.row.payStatus == 0 ? '未支付' : '已支付') : '流拍'}}
							</template>
						</el-table-column>
						<el-table-column label="时间" width="180" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								结束时间：<br>{{scope.row.endTime}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-button">
									<div class="space-button-item space-button-blue"
										@click="scopeButtonClick(scope.row, 'order')">
										<i class="el-icon-s-order"></i>
										查看订单
									</div>
									<div class="space-button-item space-button-blue"
										@click="scopeButtonClick(scope.row, 'search')"
										v-if="scope.row.auctionStatus == 3 && scope.row.payStatus == 1">
										<i class="el-icon-search"></i>
										查看藏品
									</div>
									<div class="space-button-item space-button-blue"
										@click="scopeButtonClick(scope.row, 'check')">
										<i class="el-icon-wallet"></i>
										查看保证金
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="table-item" v-show="categoryIndex == 3">
				<div class="table-title">
					全部数据（{{pageConfig.total}}）
				</div>
				<div class="table-box">
					<el-table ref="filterTable" :data="tableData" style="width: 100%" :border="true"
						:header-cell-style="{background:'#eaf0fa'}">
						<el-table-column label="数字藏品" width="400" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-commodity">
									<div class="space-commodity-image">
										<img :src="$pub.imageUrl+scope.row.lotPictrueUrl" alt="">
									</div>
									<div class="space-commodity-info">
										<div class="space-commodity-name">
											{{scope.row.lotName}}
										</div>
										<div class="space-commodity-author">
											{{scope.row.lotAuthor}}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="价格(元)" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								保证金：<br>¥{{scope.row.bondPrice}}
							</template>
						</el-table-column>
						<el-table-column label="状态" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								{{scope.row.payStatus == 1 ? '已缴费' : (scope.row.payStatus == 2 ? '已释放' : '已扣除')}}
							</template>
						</el-table-column>
						<el-table-column label="时间" width="180" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								支付时间：<br>{{scope.row.payTime}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-button">
									<div class="space-button-item space-button-blue"
										@click="scopeButtonClick(scope.row, 'check')">
										<i class="el-icon-wallet"></i>
										查看保证金
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="table-item" v-show="categoryIndex == 4">
				<div class="table-title">
					全部数据（{{pageConfig.total}}）
				</div>
				<div class="table-box">
					<el-table ref="filterTable" :data="tableData" style="width: 100%" :border="true"
						:header-cell-style="{background:'#eaf0fa'}">
						<el-table-column label="数字藏品" width="400" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-commodity">
									<div class="space-commodity-image">
										<img :src="$pub.imageUrl+scope.row.lotPictrueUrl" alt="">
									</div>
									<div class="space-commodity-info">
										<div class="space-commodity-name">
											{{scope.row.lotName}}
										</div>
										<div class="space-commodity-author">
											{{scope.row.lotAuthor}}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="价格(元)" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								当前价：<br>¥{{scope.row.currentPrice}}
							</template>
						</el-table-column>
						<el-table-column label="状态" width="125" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<span v-if="scope.row.auctionStatus == 1">未开始</span>
								<span v-if="scope.row.auctionStatus == 2">进行中</span>
								<span v-if="scope.row.auctionStatus == 3">已结束</span>
								<span v-if="scope.row.auctionStatus == 4">流拍</span>
							</template>
						</el-table-column>
						<el-table-column label="时间" width="180" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								截止时间：<br>{{scope.row.endTime}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div class="space-button">
									<div class="space-button-item space-button-red"
										@click="scopeButtonClick(scope.row,'delete')">
										<i class="el-icon-delete"></i>
										删除
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="page-pager">
				<el-pagination background layout="total, prev, pager, next" :total="pageConfig.total" :pager-count="11"
					:page-size="pageConfig.pageSize" :current-page="pageConfig.currentPage"
					@current-change="pageChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'auction',
		data() {
			return {
				categoryIndex: 0,
				category: [
					'已收藏藏品',
					'参拍藏品',
					'已拍下藏品',
					'保证金预缴款',
					'我的提醒'
				],
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 5,
					currentPage: 1,
				},
				tableData: [],
				keyword: ''
			};
		},
		watch: {
			getKeyword(keyword) {
				this.keyword = keyword
				this.fetchData()
			}
		},
		computed: {
			getKeyword() {
				return this.$store.state.spaceKeyword
			}
		},
		methods: {
			// 页面变化
			pageChange(e) {
				this.pageConfig.currentPage = e
				this.fetchData()
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				if (sign == 'order') {
					this.$router.push({
						path: '/particular',
						query: {
							id: row.lotOrderId,
							lotId: row.id ? row.id : row.lotId
						}
					})
				}
				if (sign == 'check') {
					this.$router.push({
						path: '/security',
						query: {
							id: row.bondId
						}
					})
				}
				if (sign == 'delete') {
					this.deleteCommodity(row)
				}
				if (sign == 'plus') {
					this.$router.push({
						path: '/auction',
						query: {
							id: row.id
						}
					})
				}
				if (sign == 'search') {
					this.$router.push({
						path: '/detail',
						query: {
							id: row.lotId
						}
					})
				}
			},
			// 删除商品
			deleteCommodity(row) {
				if (this.categoryIndex == 0) {
					this.deleteCollect(row)
				}
				if (this.categoryIndex == 4) {
					this.deleteRemind(row)
				}
			},
			deleteCollect(row) {
				this.$api.frontCancelCollect({
					lotId: row.id,
					memberId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.fetchData()
						this.$message({
							message: '取消收藏成功！',
							type: 'success'
						})
					}
				})
			},
			deleteRemind(row) {
				this.$api.frontRemindCancel({
					lotId: row.id,
					memberId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.fetchData()
						this.$message({
							message: '取消提醒成功！',
							type: 'success'
						})
					}
				})
			},
			changeCategory(index) {
				this.categoryIndex = index
				this.pageConfig.currentPage = 1
				this.pageConfig.total = 0
				this.tableData = []
				this.fetchData()
			},
			fetchData() {
				if (this.categoryIndex == 0) {
					this.fetchCollection()
				}
				if (this.categoryIndex == 1) {
					this.fetchJoinList()
				}
				if (this.categoryIndex == 2) {
					this.fetchBuyList()
				}
				if (this.categoryIndex == 3) {
					this.fetchSecurityList()
				}
				if (this.categoryIndex == 4) {
					this.fetchRemindList()
				}
			},
			fetchCollection() {
				this.$api.frontCollectionList({
					memberId: this.$store.state.userinfo.userId,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					lotName: this.keyword
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			},
			fetchJoinList() {
				this.$api.frontJoinList({
					memberId: this.$store.state.userinfo.userId,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					lotName: this.keyword
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			},
			fetchBuyList() {
				this.$api.frontCompleteList({
					memberId: this.$store.state.userinfo.userId,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					lotName: this.keyword
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			},
			fetchSecurityList() {
				this.$api.frontDepositList({
					memberId: this.$store.state.userinfo.userId,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					lotName: this.keyword
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			},
			fetchRemindList() {
				this.$api.frontRemindList({
					memberId: this.$store.state.userinfo.userId,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					lotName: this.keyword
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.category {
		width: 100%;
		height: 50px;
		display: flex;
		border-bottom: 2px solid @vue-border-color-red;

		.item {
			width: 20%;
			height: 50px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
		}

		.item-select,
		.item:hover {
			background: @vue-bg-color-red;
			color: @vue-text-color-inverse;
		}
	}

	.table {
		width: 100%;
		height: 754px;

		.table-title {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
		}

		.page-pager {
			width: 100%;
			height: 70px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
		}
	}
</style>
